
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';

export default {
  name: 'ProductsLandingContent',
  mixins: [eventTrackingMixins],
  components: { VueSlickCarousel },

  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      settings: {
        autoplay: false,

        arrows: true,
        dots: true,
        infinite: false,
        initialSlide: 0,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        // variableWidth: true,
        adaptiveHeight: true,
        responsive: [],
      },
      responsiveSettings: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 1,
          },
        },
      ],
      areResonsiveSettingsApplied: false,

      activeItemId: this.data[0]?.id,
      carouselKey: 0,
    };
  },

  computed: {
    ProductsPageLandingCards() {
      return this.data.find((item) => item.id === this.activeItemId)?.ProductsPageLandingCards;
    },
  },

  watch: {
    ProductsPageLandingCards() {
      // this.adjustSlidesToShow();
      this.forceRerender();
    },
  },

  // workaround solution taken from https://github.com/gs-shop/vue-slick-carousel/issues/94
  // due to hydration issue when declaring responsive setting directly
  methods: {
    initHandler() {
      if (this.areResonsiveSettingsApplied === false) {
        this.applyResponsiveSettings();
        // this.adjustSlidesToShow();
      }
    },
    applyResponsiveSettings() {
      this.settings.responsive = this.responsiveSettings;
      this.areResonsiveSettingsApplied = true;
    },
    // adjustSlidesToShow() {
    //   if (this.ProductsPageLandingCards.length < 3) {
    //     this.settings.slidesToShow = this.ProductsPageLandingCards.length;
    //   }
    // },
    toggleActiveItem(value) {
      this.activeItemId = value;
    },
    forceRerender() {
      this.carouselKey += 1;
    },
    
    handleEventTracking_decoderMain(event) {
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)

      const clickedElementHref  = dataFromClickedElement.link_node.getAttribute('href')
      const eventTrackingParams = this.initEventTrackingParams()
      
      if (dataFromClickedElement.tracking_target.target_code === 'product-page-content') {
        // #20 Decoder-main
        eventTrackingParams.a = 'go_to_decoder'
        eventTrackingParams.l =  null
        eventTrackingParams.c = `decoder_main_card`
        eventTrackingParams.cd = {
          insurer_name: null,
          product_name: null,
          product_category: clickedElementHref
        }        
      } 

      this.sendEventTracking(eventTrackingParams)
    },
  },
};
